export enum LLMProvider {
  OpenAI = 'openai',
  Anthropic = 'anthropic',
  Google = 'google',
  Mistral = 'mistral',
  Cohere = 'cohere',
  Custom = 'custom'
}

export interface LLMConfig {
  provider: LLMProvider
  apiKey: string
  baseUrl?: string
  model?: string
  maxTokens?: number
  temperature?: number
}

export interface LLMProviderInfo {
  id: LLMProvider
  name: string
  models: string[]
  defaultModel: string
  baseUrl: string
  requiresApiKey: boolean
  description: string
}

export interface ChatMessage {
  id: string
  role: 'user' | 'assistant' | 'system'
  content: string
  timestamp: Date
  provider?: LLMProvider
  model?: string
  error?: boolean
}

export interface ChatSession {
  id: string
  title: string
  messages: ChatMessage[]
  provider: LLMProvider
  model: string
  createdAt: Date
  updatedAt: Date
}

export interface StreamResponse {
  content: string
  done: boolean
  error?: string
}
